import { useState } from 'react';
import { Container, Image } from 'semantic-ui-react';
import RegisterForm from '../../components/Auth/RegisterForm/RegisterForm'; 
import LoginForm from '../../components/Auth/LoginForm/LoginForm';
import instaclone from "../../assets/png/instaclone.png";
import "./Auth.scss";

export default function Auth() {
    const [showLogin, setShowLogin] = useState(true);
  return (
  <Container fluid className="auth">
    <div className="container-form">
      {showLogin ? (
        <LoginForm />
      ) : (
        <RegisterForm setShowLogin={setShowLogin} />          
      )}
    </div>
    <div className="change-form">
      {showLogin ? (
        <>
          ¿Aún no tienes una cuenta?
          &nbsp;<span onClick={()=>setShowLogin(!showLogin)}>Registrate</span>
        </>
      ) : (
        <>
          Entra con tu cuenta
          &nbsp;<span onClick={()=>setShowLogin(!showLogin)}>Iniciar sesion</span>
        </>
      )}
    </div>
  </Container>
  );
}   